import { UsergroupAddOutlined } from '@ant-design/icons';
import React from 'react';
import EmptyItems from './common/EmptyItems';

const EmptyTeams = () => (
  <EmptyItems
    Icon={UsergroupAddOutlined}
    type="équipe"
    description="à aucune équipe"
  />
);

export default EmptyTeams;
